export const SITE = {
  name: "IBM Ibn Bachir Multimédia",
  short: "IBM",
  tagline: "Ibn Bachir Multimédia",
  phone: "+221 76 546 78 49",
  phone2: "+221 77 571 93 98",
  whatsapp: "221765467849",
  email: "seckamdy@hotmail.com",
  address: "Dakar, Sénégal",
  hours: "Lun – Sam · 9h – 19h",
};

export const GUIDE_IMG = "/images/guide.jpeg";

export const CATEGORIES = ["Ordinateurs", "Imprimantes", "Accessoires", "Réseau", "Consommables"];

export const SERVICE_TYPES = [
  "Développement de logiciel de gestion",
  "Infrastructure & Réseau",
  "Maintenance & Support",
  "Commande de matériel en gros",
  "Autre",
];

export const ORDER_STATUSES = ["nouvelle", "en_attente_paiement", "payée", "traitée", "livrée", "annulée"];
